import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { Box } from '@mui/material';
import {
  SkeletonBox,
  useDataProvider,
  useLocalization,
  useSnackbar,
} from '@ui-framework/index';
import IconLibrary from '../IconLibrary';
import DialogCloseButton from './DialogCloseButton';

function ClaimInfoDialog({ open, onClose, id }) {
  const { formatMessage } = useLocalization();
  const snackbar = useSnackbar();
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { getApiUrl, get } = useDataProvider(provider);

  const [loading, setLoading] = useState(false);

  async function fetchData() {
    setLoading(true);
    const response = await get(`${getApiUrl()}/sxcl/v1/claims/${id}`);
    if (response.ok) {
      // Show Claim Data
    } else {
      snackbar.showMessage({
        type: 'error',
        data: formatMessage({
          id: 'ACCEPT_JOB_FAILURE',
          defaultMessage: 'Error: Could not fetch the claim information',
        }),
      });
    }
    setLoading(false);
  }

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id]);

  if (loading) {
    return <SkeletonBox />;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconLibrary.Claim />
        {formatMessage({
          id: 'CLAIM_INFO_DIALOG_HEADING',
          defaultMessage: 'Claim Info',
        })}
        <DialogCloseButton disabled={loading} onClose={onClose} />
      </DialogTitle>
      <Box>Claim Info</Box>
    </Dialog>
  );
}

export default ClaimInfoDialog;
